import * as React from 'react';
import { Tile } from '../../../models/Mahjong';
import { TileImage } from './TileImage';

interface AnimatedTileImageProps {
    tile: Tile;
    height?: number;
    onClick?: () => void;
    faceDown?: boolean;
}

export function AnimatedTileImage({ tile, height, onClick, faceDown }: AnimatedTileImageProps): JSX.Element {
    const [hover, setHover] = React.useState(false);

    return (
        <div
            style={{
                transform: hover ? 'translateY(-10px)' : 'translateY(0)',
                transition: 'transform 0.2s ease-out',
                cursor: 'pointer'
            }}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            onClick={onClick}
        >
            <TileImage tile={tile} height={height} faceDown={faceDown} />
        </div>
    );
}
